import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { validateRegisterCsUser } from "../../redux/actions/validateRegisterIsActions";
import PropTypes from "prop-types";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ValidateRegisterCs = ({ history }) => {
  const query = new URLSearchParams(useLocation().search);
  const dispatch = useDispatch();
  const hasProcessed = useRef(false);
  const [validationDone, setValidationDone] = useState(false);
  const [fromHabitationFlow, setFromHabitationFlow] = useState(false);
  const { t } = useTranslation("common");

  useEffect(() => {
    if (hasProcessed.current) return;

    const token = query.get("token");
    const params = { token };

    if (token) {
      dispatch(
        validateRegisterCsUser({
          userIs: params,
          history,
        })
      );
    } else {
      history.push("/not-found");
    }

    // ✅ Détection d’un contexte temporaire (parcours habitation)
    const hasTempState =
      localStorage.getItem("habitationState") ||
      localStorage.getItem("isTempRegistered");

    if (hasTempState) {
      setFromHabitationFlow(true);
    } else {
      // ✅ Sinon redirection vers /login/classic
      setTimeout(() => {
        history.push("/login/classic");
      }, 3000);
    }

    hasProcessed.current = true;
    setValidationDone(true);
  }, [dispatch, history, query]);

  return (
    <Box
      sx={{
        maxWidth: 500,
        mx: "auto",
        mt: 10,
        textAlign: "center",
        p: 3,
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        boxShadow: 2,
      }}
    >
      {!validationDone ? (
        <>
          <CircularProgress color="primary" />
        </>
      ) : fromHabitationFlow ? (
        <>
          <Typography variant="h5" fontWeight={600}>
            ✅ {t("validation-account")}
          </Typography>
          <Typography mt={2} dangerouslySetInnerHTML={{ __html: t("close-windows-and-continue") }} />
        </>
      ) : (
        <>
          <Typography variant="h6" fontWeight={500}>
            ✅ {t("validation-account")}
          </Typography>
          <Typography mt={2}>
            {t("redirecting-to-login")}
          </Typography>
        </>
      )}
    </Box>
  );
};

ValidateRegisterCs.propTypes = {
  history: PropTypes.object.isRequired,
};
